module.exports = __webpack_public_path__ + "static/media/drive_thru.9adbfa33.svg";